import React from 'react';
import { SEO } from '../components/seo/SEO';
import { MarkdownPage } from '../components/content/MarkdownPage';
import content from '../content/insights/nis2-gdpr-ai.md?raw';

export const InsightsNis2Gdpr: React.FC = () => {
  return (
    <>
      <SEO
        title="NIS2 & GDPR for AI Workflows"
        description="Controls, logging, audit trails, and procurement-ready evidence for AI in regulated environments."
        canonical="/insights/nis2-gdpr-ai"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: 'NIS2 & GDPR for AI Workflows',
          description:
            'Controls, logging, audit trails, and procurement-ready evidence for AI in regulated environments.',
          author: { '@type': 'Organization', name: 'Integrova AI GmbH' },
          publisher: {
            '@type': 'Organization',
            name: 'Integrova AI GmbH',
            logo: { '@type': 'ImageObject', url: 'https://integrovaai.de/og-default.png' },
          },
          mainEntityOfPage: { '@type': 'WebPage', '@id': 'https://integrovaai.de/insights/nis2-gdpr-ai' },
          datePublished: '2025-12-20',
          dateModified: '2025-12-20',
        }}
      />
      <MarkdownPage
        title="NIS2 & GDPR for AI Workflows"
        eyebrow="Insights"
        content={content}
      />
    </>
  );
};

export default InsightsNis2Gdpr;
